import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { refundByIdApi } from "../../../services/billing.service";
import { toast } from "react-toastify";

const RefundModal = ({ open, onClose, id, refetch }) => {
  const initialState = {
    amount: 0,
    reason: "",
  };
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialState);
  const [confirmAmountPaid, setConfirmAmountPaid] = useState(0);

  const amountsMatch = formData?.amount === Number(confirmAmountPaid);

  const handleClose = () => {
    onClose();
    setFormData(initialState);
    setConfirmAmountPaid(0);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const parsedValue =
      type === "checkbox" ? checked : type === "number" ? Number(value) : value;

    setFormData((preValue) => ({
      ...preValue,
      [name]: parsedValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!amountsMatch) {
      toast.error("Amount and Confirm Amount doesn't match.");
      return;
    }

    setLoading(true);
    const response = await refundByIdApi(id, formData); // review further
    setLoading(false);

    if (response.code === 200 || response.code === 201) {
      toast.success("Refund added successfully");
      handleClose();
      refetch();
    } else {
      toast.error(response?.message || "Some error occurred.");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "1100px" },
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        {/* dialog title */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: "20px",
          }}
        >
          <Typography variant="h6" sx={{ color: "#5D6A82" }}>
            {"Refund"}
          </Typography>
          <Close
            onClick={handleClose}
            sx={{ cursor: "pointer", color: "#5D6A82" }}
          />
        </Box>

        <Box component="form" onSubmit={handleSubmit}>
          {/* Transaction Details */}

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                type="number"
                label="Amount (₹)"
                name="amount"
                value={formData?.amount || ""}
                onChange={handleInputChange}
                fullWidth
                required
                sx={{ bgcolor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                type="number"
                label="Confirm Amount (₹)"
                name="confirmAmountPaid"
                value={confirmAmountPaid || ""}
                onChange={(e) =>
                  setConfirmAmountPaid(Number(e.target.value) || 0)
                }
                fullWidth
                required
                error={!amountsMatch && confirmAmountPaid !== ""}
                helperText={
                  !amountsMatch && confirmAmountPaid !== ""
                    ? "Amount does not match!"
                    : ""
                }
                sx={{ bgcolor: "white" }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Reason"
                name="reason"
                value={formData?.reason || ""}
                onChange={handleInputChange}
                fullWidth
                required
                sx={{ bgcolor: "white" }}
              />
            </Grid>
          </Grid>

          {/* submit button */}
          <Box sx={{ my: "20px", textAlign: "center" }}>
            <Button
              type="submit"
              variant="contained"
              sx={{ width: "150px" }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Submit"}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default RefundModal;
